'use strict';

var processInclude = require('base/util');
var toastHelpers = require('core/components/toast');

$(document).ready(function () {
    
    $('body').on('click', '.cancel-course', function(e) {
        var course_id = $(this).data('course-id');
        var enrollment_id = $(this).data('enrollment-id');
        var order_number = $(this).data('order-number');

        $('#course_id').val(course_id);
        $('#enrollment_id').val(enrollment_id);
        $('#order_number').val(order_number);
    });

    $('body').on('click', '.account-delete-confirmation-btn', function(e) {
        e.preventDefault();

        $.spinner().start();

        var url = $('#accountDeleteModal').data('action');

        $.ajax({
            url: url,
            method: 'POST',
            data: $('#accountDeleteForm').serialize(),
            success: function (data) {
                
                $('.pending-delete').removeClass('d-none');
                $('.pending-deactivation').addClass('d-none');
                $('.account-delete-link').addClass('d-none');
                $('.account-deactivation-link').addClass('d-none');

                $.spinner().stop();
                   
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('click', '.account-deactivate-confirmation-btn', function(e) {
        e.preventDefault();

        $.spinner().start();
        
        var url = $('#accountDeactivateModal').data('action');

        $.ajax({
            url: url,
            method: 'POST',
            data: $('#accountDeactivateForm').serialize(),
            success: function (data) {
                
                $('.pending-deactivation').removeClass('d-none');
                $('.account-deactivation-link').addClass('d-none');

                $.spinner().stop();
                   
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('click', '.course-cancel-confirmation-btn', function(e) {
        e.preventDefault();

        var enrollment_id = $('#enrollment_id').val();
        
        $.spinner().start();
        
        var url = $('#courseCancelModal').data('action');

        $.ajax({
            url: url,
            method: 'POST',
            data: $('#courseCancelForm').serialize(),
            success: function (data) {
                
                $(".course-links[data-enrollment-id=" + enrollment_id +"]").find('.cancel-pending').removeClass('d-none');
                $(".course-links[data-enrollment-id=" + enrollment_id +"]").find('.course-cancel').addClass('d-none');
                toastHelpers.methods.show('warning', data.message, false);

                $.spinner().stop();
                   
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
});


